// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { warning } from 'react-notification-system-redux'
import { castToFloat } from 'helpers/reduxFormFunctions'
import { loadingToggler } from 'redux/modules/loading'
import { UNCAUGHT_ERROR } from 'errors'
import { radioIs7090 } from 'validators/common'

import {
  assembleQuery,
  fetchNewRadioCodes,
} from 'helpers/api'

const getLegacyRadioCodeForModulation = radioData => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const radioModulations = getState().databaseDetails.getIn(['initialValues', 'radioModulations'])

      try {
        const isFor7090 = radioIs7090(radioData)

        // we know we want to generate a legacyRadioCode for the radio.
        let numberOfCodesToGenerate = 1

        // but if the radio is 7090, we need to determine if there are any unsaved modulations in redux
        // because we want to properly enumerate these codes for save.
        if (isFor7090) {
          numberOfCodesToGenerate = (
            radioModulations.reduce((a, d) => (
              // if true, that means this modulation hasn't been saved to DB yet and we should add 1 to the counter
              // for proper enumeration of 7090 legacyRadioCodes.
              castToFloat(d.get('radioModulationId')) === null
                ? ++a
                : a
            ), numberOfCodesToGenerate)
          )
        }

        // generate a single legacy radio code for this new modulation
        // based on radio data, determine of this code should be 70-90 or not.
        const query = assembleQuery([{
          field: 'isFor7090',
          value: isFor7090,
        }, {
          field: 'numberOfCodesToGenerate',
          value: numberOfCodesToGenerate,
        }])

        const { entities } = await fetchNewRadioCodes(query)

        // NOTE - we do -1 here so we can dynamically get the last generated code from the request.
        // this allows us to properly sequence modulations when user is adding multiple without saving the radio.
        return entities[numberOfCodesToGenerate - 1].generatedRadioCode
      } catch (err) {
        // but it's not really a big deal if we fail to so just like want them.
        // the value will initialize as an empty string in this case.
        dispatch(warning({
          message: err.message || UNCAUGHT_ERROR,
          title: 'Failed to fetch initial value for Legacy Radio Code',
        }))

        return ''
      }
    })
  )
)

export default getLegacyRadioCodeForModulation
